import React from 'react';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import ChatMessageList from './ChatMessageList';
import ChatMessageInput from './ChatMessageInput';

const ChatBox = ({ handleSendMessage, messages, canSendMessages }) => (
  <Stack sx={{ flexGrow: 1 }}>
    <ChatMessageList messages={messages} />

    {canSendMessages && (
      <>
        <Divider />
        <ChatMessageInput onSend={handleSendMessage} />
      </>
    )}
  </Stack>
);

export default ChatBox;
